// src/utils/validators.ts

/**
 * Valida um endereço de email usando expressão regular
 * @param email Email a ser validado
 * @returns true se o email for válido, false caso contrário
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Valida um nome de usuário
 * @param name Nome a ser validado
 * @returns true se o nome for válido, false caso contrário
 */
export const validateName = (name: string): boolean => {
  return name.trim().length >= 3;
};

/**
 * Valida um número de telefone brasileiro
 * @param phone Número de telefone a ser validado
 * @returns true se o telefone for válido, false caso contrário
 * Formatos aceitos: (99) 9999-9999 ou (99) 99999-9999
 */
export const validatePhone = (phone: string): boolean => {
  // Remove todos os caracteres não numéricos
  const numbersOnly = phone.replace(/\D/g, "");

  // Verifica se o número tem 10 dígitos (fixo) ou 11 dígitos (celular)
  return numbersOnly.length === 10 || numbersOnly.length === 11;
};
